import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CreateNewBusinessComponent } from "src/app/shared/components/create-new-business/create-new-business.component";
import { UploadBusinessImageComponent } from "src/app/shared/components/upload-business-image/upload-business-image.component";
import { ViewMediaGalleryComponent } from "src/app/shared/components/view-media-gallery/view-media-gallery.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { NavigationService } from "src/app/providers/navigation.service";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { LinkQRComponent } from "../businesses/link-qr/link-qr.component";
import { AddNewEmployeeComponent } from "src/app/shared/components/add-new-employee/add-new-employee.component";
import { AddEditOwnerProfileComponent } from "src/app/shared/components/add-edit-owner-profile/add-edit-owner-profile.component";
import { StorageService } from "src/app/providers/storage.service";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-owner-profile",
  templateUrl: "./owner-profile.component.html",
  styleUrls: ["./owner-profile.component.scss"],
})
export class OwnerProfileComponent implements OnInit, OnDestroy {
  iter1: boolean = false;
  showFullBio = false;

  iter2: boolean = false;
  userPhone: any = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER);
  userDetail: any;
  entityHashId: string = "";
  employeeHashId: string = "";
  homeQRCode: any = "";
  shopQRCode: any = "";
  _entityDetails: any[] = [];
  employeeData: any = [];
  appFunctionality: any = [];
  public loader: boolean = false;
  private _apiSubscription: Subscription = new Subscription();
  // clickEventSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private dialog: MatDialog,
    private router: Router,
    private loaderService: LoaderServiceService,
    private _modelRef: MatDialog,
    private dialogService: DialogService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private storageservicce: StorageService,
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT) {
        this.userDetail = {};
        if (resData.result) {
          this.userDetail = resData.result;
          localStorage.setItem(SM_CONSTANTS.OWNER_NAME, this.userDetail.name);
          localStorage.setItem(
            SM_CONSTANTS.PROFILE_HASH,
            this.userDetail.profileHashId,
          );
          localStorage.setItem(
            SM_CONSTANTS.PROFILE_CODE,
            this.userDetail.profile_code,
          );
          localStorage.setItem(
            SM_CONSTANTS.OWNER_IMAGE,
            this.userDetail.profileThumbImg,
          );
          if (
            this.userDetail.addressInfo &&
            this.userDetail.addressInfo != "null"
          ) {
            this.userDetail.addressInfo =
              typeof this.userDetail.addressInfo == "string"
                ? JSON.parse(this.userDetail.addressInfo)
                : this.userDetail.addressInfo;
          }
        }

        this.loaderService.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_PROFILE
      ) {
        if (resData.result) {
          console.log(resData.result);
          console.log(resData.result?.verification_email_sent_status);

          if (resData.result?.verification_email_sent_status == 1) {
            this.loaderService.showLoader = false;
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "600px",
              data: {
                title: "Success!",
                message:
                  "Please verify your email using the verification link sent to your provided email.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
            this._apiService.getUserDetail(
              localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            );
          } else {
            if (resData.result?.errorcode == 0) {
              // this.loaderService.showLoader = true
              this._apiService.getUserDetail(
                localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
              );
            } else {
              console.error(resData.result);
            }
          }
        }
      }

      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_SEND_EMAIL_VERIFICATION_LINK
      ) {
        if (resData.result) {
          if (resData.result?.errorcode == 0) {
            this.loaderService.showLoader = false;
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              data: {
                title: "Success!",
                message:
                  "Verification link sent successfully. Please verify your email using the verification link sent to your provided email.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          } else {
            console.error(resData.result);
          }
        }
      }
    });
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
  }

  ngOnInit(): void {
    // this.route.queryParams.subscribe((data) => {
    //   console.log(data.entityHash);
    //   this.entityHashId = data.entityHash;
    //   this.employeeHashId = data.employeeHash;
    // });
    this.loader = true;
    this.loaderService.showLoader = true;
    this._apiService.getUserDetail(
      localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
    );

    // this._apiService.getEmployeeList(this.entityHashId);
    // this._apiService.getFunctionalityByEntityId(this.entityHashId)
    // this._apiService.getEntityDetails(this.entityHashId);

    // this._apiService.getBookingQRCodes(this.entityHashId)

    // GET_ENTITY_DETAILS_RESULT
  }
  editProfile() {
    let data = {
      title: "Edit Profile",
      ref: this._modelRef,
      data: this.userDetail,
      phone: this.userPhone,
    };
    this.dialogService.openFullScreenDialog(AddEditOwnerProfileComponent, data);
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
  }

  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  test: any = "125, Raniganj By-Pass Road, Raniganj, West Bengal 713347, India";

  sendEmailVerificationLink() {
    let data = {
      email: this.userDetail.email,
      profile_hash: this.userDetail.profileHashId,
      origin: "business",
    };

    this.loaderService.showLoader = true;
    this._apiService.sendEmailVerificationLink(data);
  }
}
